import { configureStore, getDefaultMiddleware } from "@reduxjs/toolkit";
import axios from "axios";
import thunk from "redux-thunk";
import { ACCESS_TOKEN } from "../constants.js/authToken";
import combineReducers from "../reducers/index";
import { store } from "../App";
import ContextUser from "./../contexts/user-context";

import history from "../Routes/history";

axios.interceptors.request.use(
  (config) => {
    // const token = ACCESS_TOKEN;
    const token =
      (store && store.getState().auth.token) || localStorage.getItem("token");
    if (token) {
      config.headers["Authorization"] = "Bearer " + token;
    }
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);
axios.interceptors.response.use(
  (response) => {
    sessionStorage.removeItem("showUserErrorHandling");
    return response;
  },
  (error) => {
    const status = error?.response?.status;
    
    // Handle 401 (Unauthorized) - token expired or invalid
    // NOTE: 403 (Forbidden) means authenticated but not authorized - don't redirect for that!
    if (
      status === 401 &&
      !sessionStorage.getItem("showUserErrorHandling")
    ) {
      sessionStorage.setItem("showUserErrorHandling", "true");

      let routePath = history?.location?.pathname;
      const publicRoutes = [
        "/see_all",
        "/register",
        "/forgotPassword",
        "/changePassword",
        "/changeTempPassword",
        "/external-catalog",
        "/external-bundlecodes",
        "/toCartWebsite",
        "/loginPage"
      ];

      // Check if current route is not a public route
      const isPublicRoute = publicRoutes.some(route => routePath.includes(route));
      
      if (!isPublicRoute) {
        // Clear token and user data on 401
        localStorage.removeItem("token");
        localStorage.removeItem("isTemporaryPassword");
        sessionStorage.clear();
        
        // Redirect to login page
        history.push("/loginPage");
        history.go(0);
      }
    } else if (!sessionStorage.getItem("showUserErrorHandling")) {
      // alert("For testing purpose, check network tab and report to dev");
    }
    setTimeout(() => {
      sessionStorage.removeItem("showUserErrorHandling");
    }, 1200);
    return Promise.reject(error);
  }
);
export default function configureAppStore(preloadedState) {
  const store = configureStore({
    reducer: combineReducers,
    middleware: [thunk],
    preloadedState,
  });
  return store;
}
